import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRounded: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowRounded"><Path d="M2.75 7.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H19.25M16.75 4.25L20.25 7.75M20.25 7.75L16.75 11.25M20.25 7.75H12.75C9.98858 7.75 7.75 9.98858 7.75 12.75V13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowRounded;
